import * as React from 'react';
import { LayoutGrid } from '@built/design-system';

import SetupPassword from '../containers/SetupPassword';
import SetupMfa from '../containers/SetupMfa';
import SetupComplete from '../containers/SetupComplete';
import SetupCompleteImaUser from '../containers/SetupCompleteImaUser';
import Header from '../containers/Header';
import Footer from '../components/Footer';
import { SetupState } from '../types';
import * as styles from './Setup.module.scss';
import onboardingGraphic from '../images/new-user-image.svg';
import lockGraphic from '../images/two-factor-image.svg';

/**
 * Renders the password setup view or the MFA setup view (if we
 * determined that MFA is required for the user)
 */
export default class Setup extends React.Component<SetupProps> {
  render() {
    const { updateState } = this.props;
    const { Component, Graphic } = this.getComponentAndGraphic();

    return (
      <React.Fragment>
        <Header />
        <LayoutGrid className={styles.root}>
          <LayoutGrid.Row
            nowrap={true}
            center={true}
            className={styles.contentRow}
          >
            {Graphic && (
              <LayoutGrid.Cell
                columnsXs="hide"
                columnsSm="hide"
                columnsMd={4}
                columnsLg={4}
                columnsXl={3}
                className={styles.graphicCell}
              >
                <img src={Graphic} alt="Password Setup Graphic" />
              </LayoutGrid.Cell>
            )}
            <LayoutGrid.Cell
              columnsMd={8}
              columnsLg={8}
              columnsXl={9}
              className={[styles.verticalSpacing, styles.contentCell].join(' ')}
            >
              {Component && <Component updateState={updateState} />}
            </LayoutGrid.Cell>
          </LayoutGrid.Row>
        </LayoutGrid>
        <Footer />
      </React.Fragment>
    );
  }

  getComponentAndGraphic = (): ComponentGraphic => {
    const { setupState } = this.props;

    switch (setupState) {
      case SetupState.completeImaUser:
        return { Component: SetupCompleteImaUser, Graphic: lockGraphic };
      case SetupState.needsPassword:
      case SetupState.completedPassword:
        return { Component: SetupPassword, Graphic: onboardingGraphic };
      case SetupState.needsMfa:
      case SetupState.completedMfa:
        return { Component: SetupMfa, Graphic: lockGraphic };
      default:
        return { Component: SetupComplete, Graphic: lockGraphic };
    }
  };
}

interface ComponentGraphic {
  // TODO: figure out the typing issues here
  // tslint:disable-next-line:no-any
  Component: any | undefined;
  Graphic: string | undefined;
}

export interface SetupProps {
  /**
   * The current state in the setup process. This
   * determines what component is displayed
   */
  setupState: SetupState;
  updateState(newState: SetupState): Promise<boolean>;
}
